import { useCallback, useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { DevSection } from "@/components/DevSection";
import { MarketingSection } from "@/components/MarketingSection";
import { TaxSection } from "@/components/TaxSection";
import { Portfolio } from "@/components/Portfolio";
import { WhyChoose } from "@/components/WhyChoose";
import { Process } from "@/components/Process";
import { Faq } from "@/components/Faq";
import { FinalCta } from "@/components/FinalCta";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingButtons } from "@/components/FloatingButtons";

function App() {
  const [selectedService, setSelectedService] = useState("");
  const handleEnquire = useCallback((service) => setSelectedService(service), []);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ autoRaf: true, anchors: true, duration: 1.15, smoothWheel: true });
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services onEnquire={handleEnquire} />
        <DevSection onEnquire={handleEnquire} />
        <MarketingSection onEnquire={handleEnquire} />
        <TaxSection onEnquire={handleEnquire} />
        <Portfolio />
        <WhyChoose />
        <Process />
        <Faq />
        <FinalCta />
        <Contact preselectedService={selectedService} />
      </main>
      <Footer />
      <FloatingButtons />
      <Toaster position="top-center" theme="dark" richColors closeButton />
    </div>
  );
}

export default App;
